import React from 'react';
import PropTypes from 'prop-types';

const Component = (props) => {
    const {
        numberOfProductsInCart,
        totalPriceOfProductsInCart,
    } = props;

    if (numberOfProductsInCart === 0) {
        return null;
    }

    return (
        <a className="shop-bar" href="/checkout">
            {numberOfProductsInCart}
            {numberOfProductsInCart === 1 ? ' product ' : ' producten '}
            in winkelmandje (€{totalPriceOfProductsInCart})
        </a>
    );
};

Component.propTypes = {
    numberOfProductsInCart: PropTypes.number.isRequired,
    totalPriceOfProductsInCart: PropTypes.number.isRequired,
};

export default Component;



// WEBPACK FOOTER //
// ./resources/components/shop/components/CheckoutBar.jsx